import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { SubProcesosService } from './services/sub-procesos.service';
import { BehaviorSubject } from 'rxjs';
import { SwitchAppItem } from '../shared/models/enum/switchApp.model';
import { AuthenticationService } from './login/authentication/authentication.service';
import { ToastService } from './services/toast/toast.service';
import { InputDataTaxiComponent } from './login/input-data-taxi/input-data-taxi.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ChatService } from './services/chat.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    menuMode = 'overlay';

    inputStyle = 'outlined';

    ripple: boolean;

    theme = 'teal-yellow';

    lightMenu = true;

    tokenOS: string;

    switchApp: BehaviorSubject<SwitchAppItem> = new BehaviorSubject<SwitchAppItem>(null);
    ref: DynamicDialogRef;
    showCalendar: boolean = false;


    constructor(private primengConfig: PrimeNGConfig,
        private http: HttpClient,
        private auth: AuthenticationService,
        private msg: ToastService,
        private chat: ChatService,
        private cdRef: ChangeDetectorRef,
        private zone: NgZone
    ) {
    }

    ngOnInit() {
        this.initMenu();
        this.getTokenOneSignal();
        this.listenNativeAppVersion();
        this.setLanguagePrimeng();
        this.primengConfig.ripple = true;
        this.primengConfig.overlayOptions = {
            appendTo: "body",
            mode: "modal"
        };
        this.ripple = true;
    }

    ngAfterViewChecked() {
        this.showCalendar = document.querySelector('.ng-trigger-overlayAnimation') ? true : false;
        this.cdRef.detectChanges()
    }

    setLanguagePrimeng() {
        this.http.get<any>("../../assets/translates/es.json").pipe(
            take(1)
        ).subscribe(res => {
            if (res) {
                this.primengConfig.setTranslation(res);
            } else {
                this.handleErrorLanguagePrimeng();
            }
        },
            error => {
                this.handleErrorLanguagePrimeng(error);
            });
    }

    handleErrorLanguagePrimeng(error?) {
        console.error('No se ha podido cargar el fichero de traducciones:', error);
        this.msg.showError("No se ha podido cargar el fichero de traducciones", 15000);
    }

    listenNativeAppVersion() {
        (window as any).onAppVersionReady = () => {
            this.zone.run(() => undefined);
        };
    }

    getTokenOneSignal() {
        const setToken = (token: string) => {
            if (!this.tokenOS) {
                this.tokenOS = token;
            }
        };
        (window as any).onTokenOSReady = setToken;
        const existingToken = (window as any).tokenOS;
        if (existingToken) {
            setToken(existingToken);
        }
    }

    initMenu() {
        var menuactive = this.getSessionApp();
        this.changeSwitchApp(menuactive);
    }

    changeSwitchApp(app: SwitchAppItem) {
        console.log("Cambiando aplicación a ", app);
        this.chat.stopChat();
        this.setSessionApp(app);
        this.switchApp.next(app);
        if (app?.reqmatricula) {
            this.requestMatricula();
        }

        if (app?.haveChat) {
            this.loginMensajeria();
        }
    }

    async loginMensajeria() {
        console.log("Login Mensajería");
        console.log("Datos usuario mensajería:");
        console.log(this.auth.currentUserValue.dni);
        console.log(this.auth.currentUserValue.login);
        console.log(this.auth.currentUserValue.password);

        const dni = this.auth.currentUserValue.dni;

        if (dni) {
            try {
                const res = await this.chat.getCredencialesDni(dni).toPromise();
                console.log("Credenciales obtenidas por dni", res);

                this.auth.currentUserValue.login = res.result.login;
                this.auth.currentUserValue.password = res.result.password;

                if (this.auth.currentUserValue.login && this.auth.currentUserValue.password) {

                    this.chat.loginChat().subscribe({
                        next: (token) => this.saveTokenMensajeria(token),
                        error: (err) => console.log(err),
                    });
                }
            } catch (error) {
                console.error("Error al obtener credenciales:", error);
            }
        }



        // if (this.auth.currentUserValue.dni) {
        //     this.chat.getCredencialesDni(this.auth.currentUserValue.dni)
        //         .toPromise()
        //         .then(
        //             (res) => {
        //                 console.log("Credenciales obtenidas por dni", res);
        //                 this.auth.currentUserValue.login = res.result.login;
        //                 this.auth.currentUserValue.password = res.result.password;

        //                 if (this.auth.currentUserValue.login && this.auth.currentUserValue.password) {
        //                     this.chat.loginChat()
        //                         .subscribe({
        //                             next: (token) => this.saveTokenMensajeria(token),
        //                             error: (err) => console.log(err),
        //                         });

        //                     return;
        //                 }
        //             });
        // }
    }

    saveTokenMensajeria(token: string) {
        var use = this.auth.currentUserValue;
        use.tokenMensajeria = token;
        this.auth.guardarCurrentUser(use);
        this.chat.addNewConductor({
            dni: use.dni,
            nombre: use.nomusu,
            codemple: use.codempleado,
            token: token
        }).subscribe({
            next: (res) => {
                console.log("Conductor añadido a la mensajería:", res.id);
                this.setChat(res.id);
            },
            error: (err) => console.log(err),
        })

    }

    setChat(id) {
        var use = this.auth.currentUserValue;
        use._id = id;
        this.auth.guardarCurrentUser(use);
        this.chat.initChat();
    }

    requestMatricula() {
        this.ref = this.msg.open(InputDataTaxiComponent, {
            header: "Introduce la matrícula de tu vehículo",
            closable: false,
            styleClass: "custom-confirm",
            data: {
                matricula: this.auth.currentUserValue.loginTaxis.matricula,
            }
        });

        this.ref.onClose.subscribe(res => {

            if (res) {
                this.setMatricula(res);
            }
        });
    }

    setMatricula(matricula: string) {
        var user = this.auth.currentUserValue;
        user.loginTaxis.matricula = matricula;
        this.auth.guardarCurrentUser(user);
    }

    setSessionApp(app: SwitchAppItem) {
        this.auth.setSessionSwitchApp(app);
    }

    getSessionApp() {
        return this.auth.getSessionSwitchApp();
    }
}